import { Component, Inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeatureSwitch, FeatureSwitchHistoryEntry } from '../../_models/admin/feature-switch.models';
import { BrandInfo } from '../../_models/reports/brand-info.model';
import { FeatureSwitchService } from '../../_services/feature-switch/feature-switch.service';
import { describeSwitch } from './feature-switch-summary';
import { AdminEmailComponent } from '../../shared/admin-ux/admin-email.component';

export interface FeatureSwitchHistoryData {
  item: FeatureSwitch;
  brands: BrandInfo[];
}

/**
 * The change history of one switch (latest 50, newest first): who changed it, when, and its settings
 * before and after. Opened by the page as a right-hand drawer.
 */
@Component({
  selector: 'feature-switch-history-drawer',
  standalone: true,
  imports: [DatePipe, AdminEmailComponent],
  templateUrl: 'feature-switch-history-drawer.component.html'
})
export class FeatureSwitchHistoryDrawerComponent implements OnInit {

  public rows: FeatureSwitchHistoryEntry[] = [];
  public loading = false;
  public error: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeatureSwitchHistoryData,
    private dialogRef: MatDialogRef<FeatureSwitchHistoryDrawerComponent>,
    private service: FeatureSwitchService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.service.getHistory(this.data.item.switchKey).subscribe({
      next: rows => {
        this.loading = false;
        this.rows = rows || [];
      },
      error: error => {
        this.loading = false;
        this.error = (error && error.message) || 'Could not load the history.';
      }
    });
  }

  public describe(settings: FeatureSwitchHistoryEntry['before']): string {
    return settings ? describeSwitch(settings, this.data.brands) : 'unknown';
  }

  public close(): void {
    this.dialogRef.close();
  }
}
